import Vue from 'vue';

import type { TranslateResult } from 'vue-i18n';

type Variant = 'danger' | 'success';

function $toast(
  this: Vue,
  message: TranslateResult | string,
  id: string,
  variant: Variant,
): void {
  if (document.getElementById(id)) {
    this.$bvToast.hide(id);
  }
  this.$bvToast.toast(message as string, { variant, id });
}

declare module 'vue/types/vue' {
  export interface Vue {
    $toast: typeof $toast;
  }
}

Vue.mixin({
  methods: {
    $toast,
  },
});
